import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-background-50/80 backdrop-blur-md border-b border-background-200/60">
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-file-list-3-line text-white text-lg"></i>
          </div>
          <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 whitespace-nowrap">
            Vigorbuy Spreadsheet
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-5">
          <Link to="/" className="flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap font-medium">
            <i className="ri-home-4-line text-base"></i> Home
          </Link>
          <Link to="/vigorbuy-spreadsheet-guide" className="flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
            <i className="ri-book-open-line text-base"></i> Shopping Guide
          </Link>
          <a href="#what-is" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">About</a>
          <a href="#categories" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Categories</a>
          <a href="#articles" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Guides</a>
          <a href="#safety" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">Safety</a>
          <a href="#faq" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">FAQ</a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-4 py-2 rounded-md bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap ml-2"
          >
            Buy It Now
          </a>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl text-foreground-950`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
          <Link
            to="/"
            className="flex items-center gap-2 text-sm text-foreground-700 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg font-medium"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-home-4-line text-base"></i> Home
          </Link>
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-book-open-line text-base"></i> Shopping Guide
          </Link>

          <div className="border-t border-background-200/60 my-1"></div>

          <button
            onClick={() => setMobileCatOpen(!mobileCatOpen)}
            className="flex items-center justify-between w-full text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-grid-line text-base"></i> Browse Categories
            </span>
            {mobileCatOpen ? <i className="ri-arrow-up-s-line text-foreground-400 transition-transform"></i> : <i className="ri-arrow-down-s-line text-foreground-400 transition-transform"></i>}
          </button>

          {mobileCatOpen && (
            <div className="ml-2 pl-3 border-l-2 border-accent-200 space-y-0.5 mb-1">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2.5 text-sm text-foreground-600 hover:bg-accent-50 hover:text-accent-700 transition-colors py-2 px-3 rounded-lg"
                  onClick={() => setMobileOpen(false)}
                >
                  <div className="w-6 h-6 rounded bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${cat.icon} text-accent-600 text-xs`}></i>
                  </div>
                  <span className="whitespace-nowrap">{cat.name}</span>
                  <i className="ri-arrow-right-up-line text-foreground-400 text-xs ml-auto"></i>
                </a>
              ))}
            </div>
          )}

          <div className="border-t border-background-200/60 my-1"></div>

          <a href="#what-is" className="text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg" onClick={() => setMobileOpen(false)}>About</a>
          <a href="#categories" className="text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg" onClick={() => setMobileOpen(false)}>Categories</a>
          <a href="#articles" className="text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg" onClick={() => setMobileOpen(false)}>Guides</a>
          <a href="#safety" className="text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg" onClick={() => setMobileOpen(false)}>Safety</a>
          <a href="#faq" className="text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg" onClick={() => setMobileOpen(false)}>FAQ</a>

          <div className="border-t border-background-200/60 my-1"></div>

          <span className="text-xs text-foreground-400 font-medium px-3 pt-1 pb-1">Expert Guides</span>
          <Link
            to="/vigorbuy-shoes-spreadsheet"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-footprint-line text-base"></i> Shoes Guide
          </Link>
          <Link
            to="/vigorbuy-hoodie-spreadsheet"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-t-shirt-line text-base"></i> Hoodie Guide
          </Link>
          <Link
            to="/vigorbuy-jacket-spreadsheet"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-honor-of-kings-line text-base"></i> Jacket Guide
          </Link>
          <Link
            to="/vigorbuy-streetwear-spreadsheet"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-t-shirt-line text-base"></i> Streetwear Guide
          </Link>
          <Link
            to="/vigorbuy-accessories-spreadsheet"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-glasses-line text-base"></i> Accessories Guide
          </Link>
          <Link
            to="/vigorbuy-qc-photos-guide"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-camera-line text-base"></i> QC Photos Guide
          </Link>
          <Link
            to="/vigorbuy-spreadsheet-review"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-star-line text-base"></i> Complete Review
          </Link>
          <Link
            to="/vigorbuy-spreadsheet-beginners-tips"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-lightbulb-line text-base"></i> Beginner Tips
          </Link>
          <Link
            to="/vigorbuy-spreadsheet-safe-shopping"
            className="flex items-center gap-2 text-sm text-foreground-600 hover:bg-background-100 transition-colors py-2.5 px-3 rounded-lg"
            onClick={() => setMobileOpen(false)}
          >
            <i className="ri-shield-check-line text-base"></i> Safety Guide
          </Link>

          <div className="border-t border-background-200/60 my-1"></div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full px-4 py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap mt-1"
            onClick={() => setMobileOpen(false)}
          >
            Buy It Now
          </a>
        </div>
      )}
    </header>
  );
}